export * from './svg'
export type { SvgType } from './types'
